import {
  BlogReplyModel,
  BlogCommentModel,
} from '../core/model/object/blog-model';
import { Injectable } from "@angular/core";

@Injectable()
export class TextHelper {
  faNumbers = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
  enNumbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  arabicLetters = ['ي', 'ك'];
  persianLetters = ['ی', 'ک'];

  replacePersian(faNumber: string) {
    for (let i = 0; i < this.faNumbers.length; i++) {
      faNumber = this.replaceAll(
        faNumber,
        this.faNumbers[i],
        this.enNumbers[i]
      );
    }
    return faNumber;
  }

  replaceAll(text: string, original: string, alternative: string) {
    for (let i = 0; i < text.length; i++) {
      if (text.charAt(i).match(original)) {
        text = text.substr(0, i) + alternative + text.substr(i + 1);
      }
      if (text.charCodeAt(i) === 1643) {
        text = text.substr(0, i) + '.' + text.substr(i + 1);
      }
    }
    return text;
  }

  isTextPersian(text: string): boolean {
    if (
      text.charCodeAt(0) > 128 ||
      text.charCodeAt(0) === 32 ||
      text.charCodeAt(0) === 35
    ) {
      return true;
    }
    return false;
  }

  hasTextPersian(text: string): boolean {
    for (let i = 0; i < text.length; i++) {
      if (text.charCodeAt(i) > 128 && text.charCodeAt(i) !== 8217) {
        // console.log(text.charAt(i), text.charCodeAt(i), i)
        return true;
      }
    }
    return false;
  }

  textHasMention(text: string): boolean {
    for (let i = 0; i < text.length; i++) {
      if (text.charAt(i) === '@') {
        return true;
      }
    }
    return false;
  }

  isShowMoreNeeded(text: string): boolean {
    let lineCount = Math.floor((text.length * 5.9) / (window.innerWidth - 64));
    for (let i = 0; i < text.length; i++) {
      if (text.charAt(i) === '\n') {
        lineCount++;
      }
    }
    if (lineCount < 2) {
      return false;
    }
    return true;
    // console.log(lineCount)
  }

  convertTextToHtml(text: string, tagRegex: RegExp, mentionRegex: RegExp) {
    const hashtagArray = text.match(tagRegex);
    const mentionArray = text.match(mentionRegex);
    if (hashtagArray != null && hashtagArray.length !== 0) {
      hashtagArray.forEach((tag) => {
        const j = text.indexOf(tag);
        const i = tag.length + j;
        const link = '<div class="hashTag">';
        const txt = text.slice(0, i) + '</div>' + text.slice(i);
        const txt1 = txt.slice(0, j) + link + txt.slice(j);
        text = txt1;
      });
    }
    if (mentionArray !== null && mentionArray.length !== 0) {
      mentionArray.forEach((mention) => {
        const m = mention.slice(1) + '@';
        const j = text.indexOf(mention);
        const i = mention.length + j;
        const link = '<div class="mention">';
        const txt = text.slice(0, j) + m + '</div>' + text.slice(i);
        const txt1 = txt.slice(0, j) + link + txt.slice(j);
        text = txt1;
      });
    }
    return text;
  }

  prepareComments(
    comments: BlogCommentModel[],
    tagRegex: RegExp,
    mentionRegex: RegExp
  ) {
    comments.forEach((comment) => {
      comment.text =
        '<div class="comment-username">' +
        comment.user.userName +
        '</div>' +
        '<div class="comment-fake-text">‌‌ل‌</div>' +
        comment.text;
      if (this.textHasTag(comment.text) || this.textHasMention(comment.text)) {
        comment.text = this.convertTextToHtml(
          comment.text,
          tagRegex,
          mentionRegex
        );
      }
    });
    return this.prepareReplies(comments, tagRegex, mentionRegex);
  }

  prepareComment(
    comment: BlogCommentModel,
    tagRegex: RegExp,
    mentionRegex: RegExp
  ) {
    comment.text =
      '<div class="comment-username">' +
      comment.user.userName +
      '</div>' +
      '<div class="comment-fake-text">‌‌ل‌</div>' +
      comment.text;
    if (this.textHasTag(comment.text) || this.textHasMention(comment.text)) {
      comment.text = this.convertTextToHtml(
        comment.text,
        tagRegex,
        mentionRegex
      );
    }
    return comment;
  }

  prepareReplies(comments: BlogCommentModel[], tagRegex: RegExp, mentionRegex: RegExp) {
    comments.forEach((comment) => {
      comment.replies.forEach((reply) => {
        let words = reply.text.split(' ');
        let mention = words[0];
        delete words[0];
        let text = words.join(' ');
        mention = mention.slice(1, mention.length) + mention.slice(0, 1);
        if (this.textHasTag(text) || this.textHasMention(text)) {
          text = this.convertTextToHtml(
            text,
            tagRegex,
            mentionRegex
            );
          }
        reply.text =
          '<div class="comment-username">' +
          reply.user.userName +
          '</div>' +
          '<div class="comment-fake-text">‌‌ل‌</div>' +
          '<div class="comment-reply-mention">' +
          mention +
          '</div>' +
          '<div class="reply-fake-text">‌‌ل‌</div>' +
          text;
      });
    });
    return comments;
  }

  prepareReply(reply: BlogReplyModel, tagRegex: RegExp, mentionRegex: RegExp) {
    let words = reply.text.split(' ');
    let mention = words[0];
    delete words[0];
    let text = words.join(' ');
    mention = mention.slice(1, mention.length) + mention.slice(0, 1);
    if (this.textHasTag(text) || this.textHasMention(text)) {
      text = this.convertTextToHtml(
        text,
        tagRegex,
        mentionRegex
        );
      }
    reply.text =
      '<div class="comment-username">' +
      reply.user.userName +
      '</div>' +
      '<div class="comment-fake-text">‌‌ل‌</div>' +
      '<div class="comment-reply-mention">' +
      mention +
      '</div>' +
      '<div class="reply-fake-text">‌‌ل‌</div>' +
      text;
    return reply;
  }

  textHasTag(text: string) {
    for (let i = 0; i < text.length; i++) {
      if (text.charAt(i) === '#') {
        return true;
      }
    }
    return false;
  }

  checkAlphabetUserName(userName: string): boolean {
    for (let i = 0; i < userName.length; i++) {
      if (
        userName.charCodeAt(i) !== 46 &&
        (userName.charCodeAt(i) < 48 || userName.charCodeAt(i) > 57) &&
        (userName.charCodeAt(i) < 65 || userName.charCodeAt(i) > 90) &&
        (userName.charCodeAt(i) < 97 || userName.charCodeAt(i) > 122) &&
        userName.charCodeAt(i) !== 95
      ) {
        return false;
      }
    }
    return true;
  }

  checkUserNameStarts(userName: string): boolean {
    if (userName.charAt(0) === '.') {
      return false;
    }
    return true;
  }

  checkUserNameDoubleDots(userName: string): boolean {
    if (userName.includes('..')) {
      return false;
    }
    return true;
  }

  checkUserNameEnds(userName: string): boolean {
    if (userName.charAt(userName.length - 1) === '.') {
      return false;
    }
    return true;
  }

  checkUserIsOnlyDigits(userName: string): boolean {
    for (let i = 0; i < userName.length; i++) {
      if (userName.charCodeAt(i) < 48 || userName.charCodeAt(i) > 57) {
        return true;
      }
    }
    return false;
  }

  checkUsername(username: string): string {
    if (username.length >= 3) {
      if (this.checkAlphabetUserName(username)) {
        if (this.checkUserNameStarts(username)) {
          if (this.checkUserNameDoubleDots(username)) {
            if (this.checkUserNameEnds(username)) {
              if (this.checkUserIsOnlyDigits(username)) {
                return 'correct';
              } else {
                return 'نام کاربری نمی‌تونه فقط عدد باشه.';
              }
            } else {
              return 'نقطه نمی‌تونه آخر نام کاربری قرار بگیره.';
            }
          } else {
            return 'دو نقطه پیاپی نمی‌تونه در نام کاربری قرار بگیره.';
          }
        } else {
          return 'نقطه نمی‌تونه اول نام کاربری قرار بگیره.';
        }
      } else {
        return 'نام کاربری نمی‌‌تونه فارسی باشه یا شامل (،) و (-) باشه.';
      }
    } else {
      return 'نام کاربری حداقل باید ۳ کارکتر باشه.';
    }
  }

  replaceArabicLettersWithPersian(text: string) {
    for (let i = 0; i < this.arabicLetters.length; i++) {
      for (let j = 0; j < text.length; j++) {
        if (text.charAt(j).match(this.arabicLetters[i])) {
          text =
            text.substr(0, j) + this.persianLetters[i] + text.substr(j + 1);
        }
      }
    }
    return text;
  }

  replaceDeeplinkToCorrectUrls(url: string): string {
    if (url && url.includes('deeplink')) {
      if (url.includes('recipeMainPage')) {
        return '/main/recipe';
      } else if (url.includes('tribuneMainPage')) {
        return '/main/tribune';
      } else if (url.includes('diet')) {
        return '/main/diet';
      } else if (url.includes('recipe?id')) {
        return '/recipe/' + url.split('=')[1];
      } else if (url.includes('shop')) {
        return '/shop/deeplink';
      } else if (url.includes('referral')) {
        return '/referral';
      } else {
        return null;
      }
    } else {
      return null;
    }
  }
  //         https://bentoapp.org/deeplink/profile?userName=ali
  //         https://bentoapp.org/deeplink/post?postId=adc&commentId=def
  //         https://bentoapp.org/deeplink/post?postId=adc
}
